import { observer } from 'mobx-react-lite';
import * as React from 'react';
import Select, { components, OptionProps, SingleValueProps, ValueType } from 'react-select';

import 'currency-flags/dist/currency-flags.min.css';

import './amount-input.css';

import { IAmount } from '../stores/store';
import { Currencies } from '../utils/currencies';

interface IProps {
    amount: IAmount;
    required?: boolean;
    readonly?: boolean;
    onAmountChanged: (amount: IAmount) => void;
}

export const AmountInput = observer<IProps>((props) => {
    const onCurrencyChanged = React.useCallback((val: ValueType<IOption>) => {
        const realValue = (val as IOption).value;
        props.onAmountChanged({ ...props.amount, currency: realValue });
    }, [props]);

    const onNumberChanged = React.useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
        props.onAmountChanged({ ...props.amount, value: e.target.valueAsNumber });
    }, [props]);

    return (
        <div className='amount-input'>
            {props.readonly ? (
                <div className='currency-selector-readonly'>
                    <div className={`currency-flag currency-flag-${props.amount.currency.toLowerCase()}`} />
                    {props.amount.currency}
                </div>
            ) : (
                    <Select
                        classNamePrefix='currency-selector'
                        className='currency-selector-container currency-selector'
                        options={OPTIONS}
                        onChange={onCurrencyChanged}
                        components={{ SingleValue, Option }}
                        value={findOption(props.amount.currency)} />
                )}

            <input type='number' min={0} step={0.01} value={props.amount.value ? props.amount.value : ''} placeholder='0.00' onChange={onNumberChanged} required={props.required} />
        </div>
    );
});

function findOption(currency: string): IOption | undefined {
    const v = OPTIONS.find(o => o.value === currency);
    return v;
}

interface IOption {
    value: string;
    label: string;
}

const OPTIONS = Currencies.map(c => ({
    value: c.code,
    label: c.code,
}));

const SingleValue = (props: SingleValueProps<IOption>) => {
    return (
        <components.SingleValue {...props}>
            {
                props.selectProps.menuIsOpen ?
                    '' :
                    <>
                        <div className={`currency-flag currency-flag-${props.data.value.toLowerCase()}`} /> {props.data.label}
                    </>
            }

        </components.SingleValue>
    );
};

const Option = (props: OptionProps<IOption>) => {
    return (
        <components.Option {...props}>
            <div className={`currency-flag currency-flag-${props.data.value.toLowerCase()}`} /> {props.data.label}
        </components.Option>
    );
};